<template>
  <div class="container-fluid mt-3">
    <div class="row justify-content-center">
      <div class="col-xl-6">
        <b-card no-body class="m-0 p-0">
          <b-card-header header-tag="nav">
            <b-nav card-header tabs>
              <b-nav-item to="/my/profile" exact exact-active-class="active">Profile</b-nav-item>
              <b-nav-item to="/my/invites" exact exact-active-class="active">Invites</b-nav-item>
              <b-nav-item to="/my/notifications" exact exact-active-class="active">Notifications</b-nav-item>
            </b-nav>
          </b-card-header>

          <b-card-body no-body class="m-0 p-0">
            <!-- child nav route renders here -->
            <router-view></router-view>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {},
  data() {
    return {};
  },
  created() {
  },
  mounted() {
  },
  computed: {},
  methods: {
  },
};
</script>

<style scoped>

</style>
